export const initialDisplaySettings = {
  tournamentStart: {
    enableSound: false,
    selectedSound: '',
    maxDuration: 5,
    enableSpeech: false,
    speechTextKey: 'display.defaultTournamentStartSpeechText',
  },
  levelStart: {
    enableSound: false,
    selectedSound: '',
    maxDuration: 5,
    enableSpeech: false,
    speechTextKey: 'display.defaultLevelStartSpeechText',
  },
  breakStart: {
    enableSound: false,
    selectedSound: '',
    maxDuration: 5,
    enableSpeech: false,
    speechTextKey: 'display.defaultBreakStartSpeechText',
  },
  levelEndWarning: {
    enableSound: false,
    selectedSound: '',
    maxDuration: 5,
    enableSpeech: false,
    speechTextKey: 'display.defaultLevelEndWarningSpeechText',
    secondsBeforeEnd: 60,
  },
  currentThemeName: 'midnight',
  showQrCode: false,
  tts: {
    provider: 'azure', // 'web-speech' or 'azure'
    voice: 'ja-JP-NanamiNeural',
  },
};